import { Text as x } from "troika-three-text";
import { defineQuery as u } from "bitecs";
import { Parent as f } from "../../core/ecs/components.js";
import "three";
import "../../core/validation/schemas.js";
import { WorldTransform as r, Transform as h } from "../transforms/components.js";
import "../transforms/systems.js";
import "../rendering/components.js";
import "../rendering/systems.js";
import { getScene as M } from "../rendering/utils.js";
import { Word as o, Paragraph as p } from "./components.js";
import { getTextContext as C, getTextContent as W, measureWordWidth as X, wordPosition as O } from "./utils.js";
const S = ["left", "center", "right"], Y = ["top", "middle", "bottom"], k = u([o, r]), D = {
  group: "draw",
  update(n) {
    if (n.headless) return;
    const a = M(n);
    if (!a) return;
    const i = C(n), s = k(n.world);
    for (const t of s) {
      let e = i.textMeshes.get(t);
      if (e || (e = new x(), i.defaultFont && (e.font = i.defaultFont), a.add(e), i.textMeshes.set(t, e), o.dirty[t] = 1), e.position.set(
        r.posX[t],
        r.posY[t],
        r.posZ[t]
      ), e.quaternion.set(
        r.rotX[t],
        r.rotY[t],
        r.rotZ[t],
        r.rotW[t]
      ), e.scale.set(
        r.scaleX[t],
        r.scaleY[t],
        r.scaleZ[t]
      ), o.dirty[t] === 1) {
        e.text = W(n, t), e.fontSize = o.fontSize[t], e.color = o.color[t], e.letterSpacing = o.letterSpacing[t], e.lineHeight = o.lineHeight[t] || 1.2;
        const d = n.hasComponent(t, f) ? f.entity[t] : 0, l = d && n.hasComponent(d, p);
        e.anchorX = l && S[p.anchorX[d]] || "center", e.anchorY = l && Y[p.anchorY[d]] || "middle", e.outlineWidth = o.outlineWidth[t], e.outlineColor = o.outlineColor[t], e.outlineBlur = o.outlineBlur[t], e.outlineOffsetX = o.outlineOffsetX[t], e.outlineOffsetY = o.outlineOffsetY[t], e.outlineOpacity = o.outlineOpacity[t], e.strokeWidth = o.strokeWidth[t], e.strokeColor = o.strokeColor[t], e.strokeOpacity = o.strokeOpacity[t], e.fillOpacity = o.fillOpacity[t], e.curveRadius = o.curveRadius[t], e.sync(), o.dirty[t] = 0;
      }
    }
    for (const [t, e] of i.textMeshes)
      (!n.exists(t) || !n.hasComponent(t, o)) && (a.remove(e), e.dispose(), i.textMeshes.delete(t), i.textContent.delete(t));
  }
}, T = u([o]), j = {
  group: "draw",
  update(n) {
    const a = T(n.world);
    for (const i of a) {
      if (o.dirty[i] === 0 && o.width[i] > 0) continue;
      const s = X(n, i);
      s > 0 && (o.width[i] = s, o.dirty[i] = 0);
    }
  }
}, P = u([o, f, h]), G = {
  group: "simulation",
  update(n) {
    const a = P(n.world), i = n.time.deltaTime, s = /* @__PURE__ */ new Map();
    for (const t of a) {
      const e = f.entity[t];
      if (!n.hasComponent(e, p)) continue;
      s.has(e) || s.set(e, { widths: [], entities: [] });
      const d = s.get(e);
      d.widths.push(o.width[t]), d.entities.push(t);
    }
    for (const [t, e] of s) {
      if (e.widths.some((c) => c === 0 || c === void 0)) continue;
      const d = p.gap[t], l = p.align[t], m = p.damping[t], y = m <= 0 ? 1 : 1 - Math.exp(-m * i);
      for (let c = 0; c < e.entities.length; c++) {
        const g = e.entities[c], w = O(e.widths, d, l, c);
        h.posX[g] += (w - h.posX[g]) * y;
      }
    }
  }
};
export {
  G as ParagraphArrangeSystem,
  j as WordMeasureSystem,
  D as WordRenderSystem
};
//# sourceMappingURL=systems.js.map
